import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @return {Promise<any>|Promise}
 */
export default (function () {
    var url = applyPathVariables(EndPoints.USER, {});
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true });
    return request.execute();
});
